<template>
  <div
    class="modal"
    id="emailClassificationModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div
      id="emailClassificationModalContent"
      class="modal__content modal__content--xl"
    >
      <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
        <h2 class="font-medium text-base mr-auto">
          CAMBIAR TIPO CORTE: {{ emailClassification.name }} <br />
          <!-- <app-title-custom></app-title-custom> -->
        </h2>
        <button type="button" class="close" @click="$emit('closeModal')">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="intro-y box py-10 mt-5">
        <div class="wizard flex justify-center px-5 sm:px-20">
          <div
            v-for="email in classifications"
            :key="email.position"
            class="intro-x lg:text-center flex items-center md:block flex-1 z-10 w-10"
          >
            <button
              class="w-10 h-10 rounded-full button"
              :class="
                email.checked
                  ? 'text-white bg-theme-1'
                  : 'text-gray-600 bg-gray-200'
              "
            >
              {{ email.position }}
            </button>
            <div
              class="lg:w-32 text-base lg:mt-3 ml-3 lg:mx-auto"
              :class="email.checked ? 'font-medium' : 'text-gray-700'"
            >
              {{ email.name }}
            </div>
          </div>
          <div
            class="wizard__line hidden lg:block w-2/3 bg-gray-200 absolute mt-5"
          ></div>
        </div>

        <app-loading v-if="isLoading" />

        <template v-else>
          <div
            class="px-5 sm:px-20 mt-10 pt-10 border-t border-gray-200"
            v-if="classifications[form.current]"
          >
            <div class="font-medium text-base">
              Pieza #{{ classifications[form.current].position }}
            </div>
            <form
              @submit.prevent="proccessEmailType('sum')"
              enctype="multipart/form-data"
              class="form-task"
            >
              <div v-for="error in errors" :key="error">
                <p class="px-5 py-2 grid text-red-700 font-extrabold">
                  {{ error }}
                </p>
              </div>
              <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
                <div class="col-span-12 sm:col-span-12">
                  <label>NOMBRE</label>
                  <input
                    type="text"
                    name="name"
                    class="input w-full border mt-2 flex-1"
                    v-model.lazy="classifications[form.current].name"
                    required
                    autocomplete="new-name"
                    :disabled="user.team_id != 1"
                  />
                </div>
                <div class="col-span-12 sm:col-span-12">
                  <label>TIPO</label>
                  <select
                    class="input w-full border mt-2 flex-1"
                    v-model.lazy="classifications[form.current].type"
                    required
                    :disabled="user.team_id != 1"
                  >
                    <option value="" selected disabled>
                      Seleccione una opción
                    </option>
                    <option
                      v-for="type in types"
                      :value="type.value"
                      :key="type.value"
                    >
                      {{ type.name }}
                    </option>
                  </select>
                </div>
                <div class="col-span-12 sm:col-span-12">
                  <label>CANTIDAD DE PAGINAS</label>
                  <input
                    type="number"
                    class="input w-full border mt-2 flex-1"
                    v-model.lazy="classifications[form.current].quantity"
                    min="0"
                    max="5"
                    step=".01"
                    required
                    :disabled="user.team_id != 1"
                  />
                </div>
                <div class="col-span-12 sm:col-span-12">
                  <label>HORAS</label>
                  <input
                    type="number"
                    class="input w-full border mt-2 flex-1"
                    v-model.lazy="classifications[form.current].hours"
                    min="0"
                    max="100"
                    step=".01"
                    required
                    :disabled="user.team_id != 1"
                  />
                </div>
              </div>
              <div class="px-5 py-3 text-left border-t border-gray-200">
                <button
                  type="button"
                  class="btn btn-secondary w-24"
                  @click="proccessEmailType"
                >
                  Anterior
                </button>
                <button
                  type="submit"
                  class="button text-white"
                  :class="isLastElement ? 'btn-secondary' : 'bg-theme-1'"
                  :disabled="isLastElement"
                >
                  Siguiente
                </button>

                <button
                  v-if="isLastElement && user.team_id == 1"
                  type="submit"
                  class="button bg-theme-1 text-white float-right"
                  :disabled="buttonisLoading"
                >
                  {{ buttonisLoading ? 'Cargando...' : 'Guardar Cambios' }}
                </button>
              </div>
            </form>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/admin/partials/LoadingWhite'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'EmailClassificationModal',
  props: ['email'],
  data() {
    return {
      buttonisLoading: false,
      isLoading: false,
      form: {
        entity: 'emailclassification',
        current: 0,
        email_id: null,
      },
      classifications: [],
      types: [
        { name: 'Dinamico', value: 'dinamico' },
        { name: 'Estático', value: 'estatico' },
      ],
      emailClassification: {},
      errors: [],
    }
  },
  async beforeMount() {
    document.body.className = 'overflow-hidden'
    this.isLoading = true
    try {
      let view = {
        entity: 'emailclassification',
        id: this.email.id,
      }

      const response = await this.show(view)
      this.emailClassification = response

      let classifications = this.emailClassification.classifications

      for (let index = 1; index <= this.emailClassification.number; index++) {
        let baseIndex = index - 1
        if (
          classifications[baseIndex] == undefined ||
          classifications.length == 0
        ) {
          let emailClassification = this.deffineEmailClassification(index)
          this.classifications.push(emailClassification)
        } else {
          let element = {
            position: index,
            name: classifications[baseIndex].name,
            type: classifications[baseIndex].type,
            quantity: classifications[baseIndex].quantity,
            checked: index == 1 ? true : false,
            email_id: classifications[baseIndex].email_id,
            hours: classifications[baseIndex].hours,
            slug: classifications[baseIndex].slug,
          }
          this.classifications.push(element)
        }
      }
      this.form.email_id = this.emailClassification.id
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  },
  beforeDestroy() {
    document.body.classList.remove('overflow-hidden')
  },
  methods: {
    deffineEmailClassification(position) {
      return {
        position: position,
        name: null,
        type: null,
        quantity: 1,
        checked: position == 1 ? true : false,
        email_id: this.emailClassification.id,
        hours: 0,
        slug: null,
      }
    },
    async proccessEmailType(operation) {
      if (this.isLastElement && operation == 'sum') {
        await this.createEmailClassification()
        return
      }

      let oldCurrent =
        operation == 'sum' ? this.form.current + 1 : this.form.current - 1

      if (oldCurrent < 0 || (this.isLastElement && operation == 'sum')) {
        return
      }

      if (operation == 'sum') {
        this.classifications[oldCurrent].checked = true
      } else {
        this.classifications[this.form.current].checked = false
      }

      this.form.current = oldCurrent
    },
    async createEmailClassification() {
      let vm = this
      vm.buttonisLoading = true
      vm.form.classifications = vm.classifications
      await vm
        .store(vm.form)
        .then((item) => {
          vm.$emit('closeModal')
        })
        .catch((message) => {
          //
        })
        .finally(() => {
          vm.buttonisLoading = false
        })
    },
    ...mapActions(['getList', 'store', 'update', 'show']),
  },
  computed: {
    isLastElement() {
      return this.classifications.length <= this.form.current + 1
    },
    ...mapGetters({
      user: 'getUser',
    }),
  },
  components: {
    appLoading: Loading,
  },
}
</script>

<style>
#emailClassificationModal {
  visibility: initial;
  opacity: unset;
  z-index: 100000000000;
  margin: unset;
  display: flex;
}

#emailClassificationModalContent {
  margin-top: auto;
  margin-bottom: auto;
}
</style>



// WEBPACK FOOTER //
// EmailClassificationModal.vue?780d901c